import { useFetchClient } from 'utils/src/services/DataFetchClient';
import { CacheProvider } from 'rest-hooks';
import { ThemeProvider } from 'react-components';
import { useAuthentication } from '@data/auth/transition';
import { UserWorkspaceProvider } from '@hooks/use-user-workspace';
import { IntercomProvider } from '@benepass/intercom';
import MinScreenProvider from 'utils/src/hooks/use-min-screen';
import FetchContext from 'utils/src/context/FetchContext';
import MobileAppStoresModal from './components/mobile-app-stores-modal';

const Providers = ({ children }: React.PropsWithChildren) => {
  const client = useFetchClient(useAuthentication);
  const { user } = useAuthentication();
  const shouldLoad = user?.email?.includes('@getbenepass.com') ?? false;

  return (
    <CacheProvider>
      <ThemeProvider>
        <MobileAppStoresModal>
          <FetchContext.Provider value={client}>
            <MinScreenProvider
              screens={{
                sm: '640px',
                md: '768px',
                lg: '1024px',
                xl: '1280px',
                '2xl': '1536px',
              }}
            >
              <UserWorkspaceProvider>
                <IntercomProvider
                  appId={process.env.REACT_APP_INTERCOM_APP_ID}
                  hideDefaultLauncher
                  shouldLoad={shouldLoad}
                >
                  {children}
                </IntercomProvider>
              </UserWorkspaceProvider>
            </MinScreenProvider>
          </FetchContext.Provider>
        </MobileAppStoresModal>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default Providers;
